import '../App.css';
import React from 'react';
import { HeroSection } from '../Components/home/HeroSection';
import { Footer } from '../Components/Footer';
import StudentSection from '../Components/home/StudentSection';
import StudentManagementDashboardSection from '../Components/home/StudentManagementDashboardSection';
import NexusSection from '../Components/home/NexusSection';
import PracticeTestSection from '../Components/home/PracticeTestSection';
import StudyGuideSection from '../Components/home/StudyGuideSection';
import SupportSection from '../Components/home/SupportSection';
import ContactTestimonialCarousel from '../Components/contact/ContactTestimonialCarousel';
import HeaderAlt from '../Components/HeaderAlt';
function Home() {

  return (
    <div className="Home">
      <HeaderAlt />
      <HeroSection />

      <StudentSection />

      <StudentManagementDashboardSection />
      <NexusSection />
      <StudyGuideSection />
      <PracticeTestSection />
      <SupportSection />
      <ContactTestimonialCarousel />
      {/* <div className="container !mb-12 !mt-14">
        <FreeTrial />
      </div> */}
      {/* <CallToActionSection />
      <Divider />
      <NewsletterSignupSection />
      <Divider />
      <ContactUsSection /> */}
      <Footer />
    </div>
  );
}

export default Home;
